// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5lb4t","left":"styles_left__1lI8I","desktopActions":"styles_desktopActions__2vD-L","title":"styles_title__393zw"};